import { ArrowBack } from '@mui/icons-material';
import { Breadcrumbs as Crumbs, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import useBreadcrumbsStyles from './styles';
import { BreadCrumbsProps } from './types';

const Breadcrumbs: React.FunctionComponent<BreadCrumbsProps> = (props) => {
  const { isShown, wasShown } = props;

  const classes = useBreadcrumbsStyles(props);
  const { t } = useTranslation('common');
  const { spacing } = useTheme();
  const hiddenStyles = { height: 0, marginBottom: 0, overflow: 'hidden' };
  const shownStyles = { height: 'auto', marginBottom: spacing(0.5), overflow: 'visible' };

  const initial = wasShown ? shownStyles : hiddenStyles;
  const animate = isShown ? shownStyles : hiddenStyles;

  let location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const renderBackButton = () => {
    return (
      <motion.div
        initial={initial}
        animate={animate}
        key='backButton'
        transition={{ duration: 0.3 }}
      >
        <Crumbs aria-label='breadcrumb'>
          <Link to='/' className={classes.backButton}>
            <ArrowBack className={classes.arrowBack} fontSize='small' />
            {t('modules')}
          </Link>
          {pathnames.map((value, index) => {
            const last = index === pathnames.length - 1;
            const to = `/${pathnames.slice(0, index + 1).join('/')}`;
            const module = value.replace('map', '').toUpperCase();

            if (last) {
              return null;
            }

            return (
              <Link key={index} to={to} className={classes.backButton}>
                {t(module)}
              </Link>
            );
          })}
        </Crumbs>
      </motion.div>
    );
  };

  return renderBackButton();
};

export default Breadcrumbs;
